import { dayjs, shortUuid } from '@tunasong/models'
import { isAudioClip, isEntityClip } from '@tunasong/schemas'
import type { Clip, EntityClip as IEntityClip } from '@tunasong/schemas'
import type { Recorder } from '../../recorder/index.js'
import AudioClip from './audio-clip.js'
import type { ClipProps } from './clip-container.js'
import EntityClip from './entity-clip.js'

export const getClipComponent = (clip: Clip) => {
  const Component = isAudioClip(clip)
    ? AudioClip
    : isEntityClip(clip)
      ? EntityClip
      : (props: ClipProps) => <>No clip component found for {props.clip.type}</>

  return Component
}

/**
 * A recorded clip, saved as an entity clip under an id assigned here, and its recording to upload under that id.
 * The track never stores the recording's `blob:` URL, which is gone after a reload (GH #2621).
 */
export const createClip = (recorder: Recorder, start: number, duration: number) => {
  const recording = recorder.getRecording()
  if (!recording) {
    return null
  }
  const clip: IEntityClip = {
    name: dayjs().format('LL'),
    start,
    duration,
    type: 'entityclip',
    entityId: shortUuid(),
  }
  return { clip, recording }
}
